import { ASSETS_GRAPH_DATA } from "constants/actionTypes";
import { ASSETS_FILTER_DATA } from "constants/types";
import { getAssetGraphDataService } from "modules/Services/CampaignsService";
import { getAllTimeDates, getDay, getMonthDates, getQuarterDates, getQueryParam, getWeekDates, objectToQueryParams } from "utils";
import store from "../../../store/index";
import { IAssetItem, IGraphData, SelectOption } from "../interfaces";

export const assetTypeFilterChange = (value: SelectOption) => {
  store.dispatch({
    type: ASSETS_FILTER_DATA.SET_CAMPAIGN,
    payload: value,
  });
};

export const graphUserChanged = (userId: any) => {
  store.dispatch({
    type: ASSETS_GRAPH_DATA.SET_USER,
    user_id: userId,
  });
};

export const userFilterChange = (value: SelectOption) => {
  store.dispatch({
    type: ASSETS_FILTER_DATA.SET_USER,
    payload: value,
  });
  graphUserChanged(value.value);
};

export const datesFilterChange = (value: SelectOption) => {
  let datesObject: any = {};

  switch (value.value) {
    case "all":
      datesObject = getAllTimeDates();
      break;

    case "qtr":
      datesObject = getQuarterDates();
      break;

    case "month":
      datesObject = getMonthDates();
      break;

    case "week":
      datesObject = getWeekDates(7);
      break;

    case "day":
      datesObject = getDay(2);
      break;

    default:
      break;
  }
  store.dispatch({
    type: ASSETS_FILTER_DATA.SET_DATE,
    start_date: datesObject.start_date,
    end_date: datesObject.end_date,
  });
  store.dispatch({
    type: ASSETS_GRAPH_DATA.SET_DATES,
    ...datesObject,
  });
  // console.log("Dates : ", value.label, datesObject);
};

// export const getFilteredAssetsList = (params: any) => {
//   const queryParams = objectToQueryParams(params);
//   store.dispatch({
//     type: ASSETS_FILTER_DATA.LOAD,
//     payload: [],
//   });
//   getFilteredAssetsListService(queryParams)
//     .then(({ data }: any) => {
//       const assetsList: IAssetItem[] = data;
//       // console.log("Filtered Data Assets :", assetsList);
//       store.dispatch({
//         type: ASSETS_FILTER_DATA.SUCCESS,
//         payload: assetsList,
//       });
//     })
//     .catch((err) => {
//       console.log(err);
//       store.dispatch({
//         type: ASSETS_FILTER_DATA.FAIL,
//         payload: Array<IAssetItem>(),
//       });
//       // show error alert on frontend
//     });
// };

export const resetFilteredAssetsList = () => {
  store.dispatch({
    type: ASSETS_FILTER_DATA.RESET,
  });
  store.dispatch({
    type: ASSETS_GRAPH_DATA.CLEAR,
  });
};

export const getAssetsGraphData = () => {
  const start_date = store.getState().assetGraphData.startDate;
  const end_date = store.getState().assetGraphData.endDate;
  const user_id = store.getState().assetGraphData.userId;
  console.log(start_date, end_date);
  if (start_date === "" || end_date === "") return;
  let params: any = { start_date, end_date };
  if (user_id && user_id !== "default") params.user_id = user_id;
  const queryParams = objectToQueryParams(params);
  store.dispatch({
    type: ASSETS_GRAPH_DATA.LOAD,
  });
  let campaignId = getQueryParam("campaign_id");
  getAssetGraphDataService(campaignId, queryParams)
    .then((res: any) => {
      const serializedData: IGraphData = res.data;
      console.log("Assets Graph : ", serializedData);
      store.dispatch({
        type: ASSETS_GRAPH_DATA.LOAD_SUCCESS,
        payload: serializedData,
      });
    })
    .catch((err: any) => {
      console.log(err);
      console.log("OKAY SO WE FAILED TO FETCH");
      store.dispatch({
        type: ASSETS_GRAPH_DATA.LOAD_FAIL,
        payload: {},
      });
      // show error alert on frontend
    });
};
